// organize-imports-ignore
import "./index.scss";
import "./di/inversify.config";
import "./i18n";
// Extended native types
import "./@types/index";
// Yup extended schemas
import "./modules/core/presentacion/component/form/yup/string";
// Sentry configuration
import { router } from "@routes/router";
import * as Sentry from "@sentry/react";
import { configure } from "mobx";
import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import reportWebVitals from "./report-web-vitals";

// Initialize Sentry
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
const sentryEnvironment =
    process.env.REACT_APP_SENTRY_ENVIRONMENT || "development";

if (sentryDsn) {
    Sentry.init({
        dsn: sentryDsn,
        environment: sentryEnvironment,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: sentryEnvironment === "production" ? 0.1 : 1.0,
        replaysSessionSampleRate:
            sentryEnvironment === "production" ? 0.1 : 1.0,
        replaysOnErrorSampleRate: 1.0,
        beforeSend(event: Sentry.Event) {
            // Don't send events in development
            if (sentryEnvironment === "development") {
                return null;
            }
            return event;
        },
    });

    const startReplay = (): void => {
        void import(
            /* webpackChunkName: "sentry-replay" */ "./sentry-replay"
        ).then(({ attachSentryReplay }) => {
            attachSentryReplay();
        });
    };

    if (typeof requestIdleCallback === "function") {
        requestIdleCallback(() => startReplay());
    } else {
        window.setTimeout(startReplay);
    }
}

configure({
    computedRequiresReaction: true,
    enforceActions: "always",
    observableRequiresReaction: true,
});

const root = createRoot(document.getElementById("root") as HTMLElement);

const index = (
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

root.render(index);

/*
 * If you want to start measuring performance in your app, pass a function
 * to log results (for example: reportWebVitals(console.log))
 * or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
 */
reportWebVitals();
